import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

import { functionUri, storageDomain } from 'src/constants';
import { ReviewCategoriesResponse } from 'src/types/reviewsCategoriesResponse';

import Preloader from '../../components/UI/Preloader';
import CategoryPreview from '../../components/ReviewsCatalog/CategoryPreview';
import { ReviewViewer } from '../ReviewViewer';

import styles from './ReviewsCatalog.module.scss';

type Category = {
    Prefix: string;
};

export interface IReviewConfig {
    offset: number[];
    reverse: boolean;
    reversed: boolean;
    cycled: boolean;
}

const ReviewsCatalog: React.FC = () => {
    const location = useLocation();

    const [categories, setCategories] = useState<
        { imagePath: string; path: string; name: string }[]
    >([]);
    const [frames, setFrames] = useState<string[][]>([]);
    const [isReverseMove, setReverseMove] = useState<boolean>(false);
    const [isCycled, setCycled] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);
        setReverseMove(false);
        setFrames([]);
        const categoryPath = location.pathname.replace('/reviews', '');
        axios
            .get<ReviewCategoriesResponse>(`${functionUri}?path=${categoryPath}&isReview=true`)
            .then(async response => {
                const isFrames = response.data.Contents.some(
                    item => item.Key.indexOf('step-') !== -1,
                );
                if (isFrames) {
                    const searchParams = new URLSearchParams(window.location.search);
                    const offset: number[] = searchParams.has('offset')
                        ? JSON.parse(searchParams.get('offset') || '')
                        : null;
                    const reverse = searchParams.has('reverse')
                        ? searchParams.get('reverse')
                        : null;

                    let configUri = response.data.Contents.find(
                        item => item.Key.indexOf('config.json') !== -1,
                    )?.Key;
                    if (categoryPath.includes('masks'))
                        configUri = categoryPath.replace('masks', '').substring(1) + 'config.json';
                    let config: IReviewConfig;
                    if (configUri) {
                        const resp = await axios.get<IReviewConfig>(`${storageDomain}${configUri}`);
                        config = resp.data;

                        if (config?.reversed || config?.reverse) setReverseMove(true);
                        if (!config?.cycled) setCycled(config?.cycled);
                    }

                    setFrames(prev => {
                        const obj: { [key: number]: string[] } = {};
                        response.data.Contents.forEach(item => {
                            if (item.Key.indexOf('step') !== -1) {
                                const step = parseInt(item.Key.split('-')[1]);
                                if (!obj[step]) obj[step] = [];
                                obj[step].push(item.Key);
                            }
                        });

                        return Object.keys(obj)
                            .map(key => obj[parseInt(key)])
                            .map(arr =>
                                arr.sort((a, b) => {
                                    const index1 = parseInt(a.split('-')[2]);
                                    const index2 = parseInt(b.split('-')[2]);

                                    return index1 - index2;
                                }),
                            )
                            .map((list, i) => {
                                const tempList = [];
                                if (config) {
                                    const index = offset?.length ? offset[i] : config.offset[i];

                                    if (config.offset?.length > i || offset?.length > i) {
                                        for (let j = index; j < list.length; j++) {
                                            tempList.push(list[j]);
                                        }
                                        for (let j = 0; j < index; j++) {
                                            tempList.push(list[j]);
                                        }
                                    } else {
                                        for (let j = 0; j < list.length; j++) {
                                            tempList.push(list[j]);
                                        }
                                    }

                                    if (reverse || config.reverse || config.reversed)
                                        return tempList.reverse();

                                    return tempList;
                                } else return list;
                            });
                    });
                } else {
                    let categories = [];
                    for (let category of response.data.CommonPrefixes) {
                        let categoryImage = await axios.get<ReviewCategoriesResponse>(
                            `${functionUri}?path=${category.Prefix}&isReview=true`,
                        );

                        categories.push({
                            imagePath: categoryImage.data.Contents[2]?.Key,
                            path: category.Prefix,
                            name: category.Prefix.split('/').reverse()[1],
                        });
                    }
                    setCategories(categories);
                }
                setIsLoading(false);
            });
    }, [location]);

    return (
        <div className={styles.scroll}>
            {isLoading ? (
                <Preloader fullScreen />
            ) : categories.length && !frames?.length ? (
                <div className={styles.ModelsCatalog}>
                    {categories.map(category => (
                        <CategoryPreview
                            imagePath={category.imagePath}
                            key={category.path}
                            categoryPath={category.path}
                            name={category.name}
                        />
                    ))}
                </div>
            ) : (
                <ReviewViewer frames={frames} reverseMove={isReverseMove} cycledMove={isCycled} />
            )}
        </div>
    );
};

export default ReviewsCatalog;
